import { useRuntimeConfig } from "#imports";
export function buildRokkaUrl(stack, dpr = "", hash = "", name, overrideHost, variables) {
  const host = overrideHost || useRuntimeConfig().public.rokkaHost;
  const parts = [host, stack];
  const modifierParts = [];
  if (variables) {
    let variablesString = "w-" + variables.w;
    if (variables.h) {
      variablesString += "-h-" + variables.h;
    }
    modifierParts.push("variables-" + variablesString);
  }
  if (dpr) {
    modifierParts.push("options-dpr-" + dpr);
  }
  parts.push(modifierParts.join("--"));
  parts.push(hash);
  parts.push(encodeURIComponent((name || "image.jpg").replace(".pdf", ".jpg")));
  return "https://" + parts.join("/");
}
